import useMyInfo from './useAuth';
export default useMyInfo;
